import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';

const {
  queryNonSvipUserPosition,
  querySvipUserInfo,
  querySvipRightDescription,
  querySvipRights,
  querySvipUserLevelRights,
  querySvipUserTotalCent,
  querySvipUserCloudTelInfo,
  querySvipUserRightValue,
  useSvipUserRights,
  querySvipUserCentRecord,
  memberInfo,
  querySvipUserAvailableRights,
  querySvipUserLevelRightsVtwo,
  queryPreReduceGrowthValue,
  queryGrowthValueMonthLog,
  queryGrowthValueDetailLog,
  queryGrowthValueDesc,
  queryGrowthValueReduceRuleConf,
  queryGrowthValueAddRuleConf,
  queryGrowthValueDropDownConf
} = httpApi.userMember;

// 未激活权益
export interface iconProps {
  rightTitle: string;
  imageUrl: string;
}
export interface messageProps {
  rightTitle: string;
  rightMessage: string;
}
export interface SVIPUserProps {
  icon: iconProps[];
  message: messageProps[];
}
export function apiGetSVIPUser() {
  return request<SVIPUserProps>({
    method: 'GET',
    url: queryNonSvipUserPosition
  });
}

// SVIP用户信息查询
export interface SvipUserInfoProps {
  growthValue: number;
  headImg: string;
  levelLogoUrl: string;
  rechargeAmount: number;
  state: number;
  svipLevel: number;
  userId: number;
  userName: string;
}
export function apiGetSvipUserInfo() {
  return request<SvipUserInfoProps>({
    method: 'GET',
    url: querySvipUserInfo
  });
}

// SVIP等级配置说明查询
interface tableHeaderProps {
  title: string;
  key: string;
}
interface dataListProps {
  [key: string]: string;
}
export interface SvipDescProps {
  tableHeader: tableHeaderProps[];
  dataList: dataListProps[];
}
export function apiGetSvipDesc() {
  return request<SvipDescProps>({
    method: 'GET',
    url: querySvipRightDescription
  });
}

// SVIP等级配置说明查询
export interface levelGrowthValueProps {
  growthValue: number;
  level: number;
}
export interface rightConfProps {
  rightCode: string;
  rightLogoUrl: string;
  rightMessage: string;
  rightName: string;
  rightSubtitle: string;
  rightTitle: string;
  state: number;
}
export interface QuerySvipRightsProps {
  growthValue: number;
  levelGrowthValue: levelGrowthValueProps[];
  rightConf: rightConfProps[];
  svipLevel: number;
  svipLevelCount: number;
}
export function apiGetQuerySvipRights() {
  return request<QuerySvipRightsProps>({
    method: 'GET',
    url: querySvipRights
  });
}

// 用户等级特权查询
interface querySvipUserLevelRightsParams {
  svipLevel: number;
  userId?: number;
}
export interface SvipUserLevelRightsProps {
  rightCode: string;
  rightState: number;
  rightValue?: number;
  rightCondition: number;
  unit: string;
  upFlag: boolean;
  unlockSvipMessage?: string;
}
export function apiGetSvipUserLevelRights(params: querySvipUserLevelRightsParams) {
  return request<SvipUserLevelRightsProps[]>({
    method: 'GET',
    url: querySvipUserLevelRights,
    params
  });
}

// 用户等级特权查询v2
export interface multiTypeRightsProps {
  typeFlag: boolean;
  typeName: string;
  rights: SvipUserLevelRightsProps[];
}
export interface SvipUserLevelRightsVtwoProps {
  gameCode: string;
  gameDescribe: string;
  upgradeDescribe: string;
  gameTotal: number;
  usableRightsNum: number;
  newGameFlag: boolean;
  usableRights: SvipUserLevelRightsProps[];
  multiTypeRights: multiTypeRightsProps[];
}
export function apiQuerySvipUserLevelRightsVtwo(params: querySvipUserLevelRightsParams) {
  return request<SvipUserLevelRightsVtwoProps>({
    method: 'GET',
    url: querySvipUserLevelRightsVtwo,
    params
  });
}

// 用户领取积分总数查询
interface querySvipUserTotalCentParams {
  userId?: number;
}
export interface SvipUserTotalCentProps {
  dailyScore: number;
  monthScoreTotal: number;
  monthScoreUpperLimit: number;
  rightUser: boolean;
  showState: number;
  topLimitFlag: boolean;
  totalCent: number;
}
export function apiGetQuerySvipUserTotalCent(params: querySvipUserTotalCentParams) {
  return request<SvipUserTotalCentProps>({
    method: 'GET',
    url: querySvipUserTotalCent,
    params
  });
}
// 用户云手机权益信息查询
export interface querySvipUserCloudTelInfoProps {
  creditTime: number;
  rightCondition: number;
  rightValue: number;
  state: number;
  svipLevel: number;
}
export function apiGetQuerySvipUserCloudTelInfo(params: querySvipUserTotalCentParams) {
  return request<querySvipUserCloudTelInfoProps[]>({
    method: 'GET',
    url: querySvipUserCloudTelInfo,
    params
  });
}

// 用户权益值可领取情况查询
interface querySvipUserRightValueParams extends querySvipUserTotalCentParams {
  rightCode: string;
}
export interface querySvipUserRightValueProps {
  rightState: number;
  rightValue: number;
  svipLevel: string;
  rightBanFlag?: boolean;
}
export function apiGetQuerySvipUserRightValue(params: querySvipUserRightValueParams) {
  return request<querySvipUserRightValueProps>({
    method: 'GET',
    url: querySvipUserRightValue,
    params
  });
}

// 用户云手机权益领取接口
export interface useSvipUserRightsProps {
  rightState: number;
}
export function apiGetUseSvipUserRights(data: querySvipUserRightValueParams) {
  return request<useSvipUserRightsProps>({
    method: 'POST',
    url: useSvipUserRights,
    data
  });
}

// 用户每月领取积分总数查询
export interface QuerySvipUserCentRecordProps {
  availableCent: number;
  month: string;
  usedCent: number;
  yearMonth: string;
}
export function apiGetQuerySvipUserCentRecord(params: querySvipUserTotalCentParams) {
  return request<QuerySvipUserCentRecordProps[]>({
    method: 'GET',
    url: querySvipUserCentRecord,
    params
  });
}
// 查询当前用户信息
interface teamProps {
  team_id: number;
  template_id: number;
}
interface UserInfoProps {
  customer_service: teamProps;
}
export function apiGetUserInfo() {
  return request<UserInfoProps>({
    method: 'GET',
    url: memberInfo
  });
}

// SVIP用户未领取权益查询
interface QuerySvipUserAvailableRightsProps {
  rightName: string;
  rightSubtitle: string;
  rightTitle: string;
  rightValue: number;
}
export function apiGetQuerySvipUserAvailableRights(params: querySvipUserTotalCentParams) {
  return request<QuerySvipUserAvailableRightsProps[]>({
    method: 'GET',
    url: querySvipUserAvailableRights,
    params
  });
}

export interface ReduceProps {
  message: string;
  reduceFlag: boolean;
}
// 用户成长值预扣除情况查询
export function apiQueryPreReduceGrowthValue() {
  return request<ReduceProps>({
    method: 'GET',
    url: queryPreReduceGrowthValue
  });
}

// 成长值说明
export function apiQueryGrowthValueDesc() {
  return request<ReduceProps>({
    method: 'GET',
    url: queryGrowthValueDesc
  });
}

interface ValueDetailLogProps {
  detailFlag: boolean;
  increaseGrowthValue: number;
  monthDate: string;
  monthDateDesc: string;
  reduceGrowthValue: number;
}
// 用户成长值按月汇总记录
interface QueryGrowthValueMonthLogProps {
  lastMonths: string | number;
}
export function apiQueryGrowthValueMonthLog(params: QueryGrowthValueMonthLogProps) {
  return request<ValueDetailLogProps[]>({
    method: 'GET',
    url: queryGrowthValueMonthLog,
    params
  });
}

// 用户成长值明细记录
interface QueryGrowthValueDetailLogProps {
  monthDate: string | number;
  page: number;
  size: number;
}
export function apiQueryGrowthValueDetailLog(params: QueryGrowthValueDetailLogProps) {
  return request<any>({
    method: 'GET',
    url: queryGrowthValueDetailLog,
    params
  });
}

// 成长值扣除规则配置
export function apiQueryGrowthValueReduceRuleConf() {
  return request<any>({
    method: 'GET',
    url: queryGrowthValueReduceRuleConf
  });
}

// 成长值增加规则配置
export function apiQueryGrowthValueAddRuleConf() {
  return request<any>({
    method: 'GET',
    url: queryGrowthValueAddRuleConf
  });
}

export interface TimeTypeProps {
  name: string;
  value: string;
}
// 查询成长值明细下拉列表配置
export function apiQueryGrowthValueDropDownConf() {
  return request<TimeTypeProps>({
    method: 'GET',
    url: queryGrowthValueDropDownConf
  });
}
